// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"center-focus-strong"},"nodeName":"g","children":[{"attributes":{"id":"fill2","cx":12,"cy":12,"r":3,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8 3H3V8M16 3H21V8M8 21H3V16M16 21H21V16","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","cx":12,"cy":12,"r":3,"stroke":"currentColor","stroke-width":2},"nodeName":"circle","children":[]}]}]};

@tag('t-icon-center-focus-strong')
export default class CenterFocusStrongIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'center-focus-strong',
    }
  }
}
